import { Button, Container, Grid, Link } from "@mui/material";
import { useAccount, useConnect, useDisconnect } from "wagmi";

export const Header = () => {
  const { connect, connectors, status } = useConnect();
  const { disconnect } = useDisconnect();
  const { data: account } = useAccount();
  const accountAbbr = account
    ? `${account.address.slice(0, 5)}...${account.address.slice(-4)}`
    : "";

  const buttonText =
    status === "connected"
      ? accountAbbr
      : status === "connecting"
      ? "Connecting"
      : "Connect";

  const buttonAction =
    status === "connected" ? disconnect : () => connect(connectors[0]);

  return (
    <Container
      sx={{
        position: "fixed",
        height: "60px",
        width: "100%",
        left: "50%",
        transform: "translateX(-50%)",
      }}
    >
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ height: "100%" }}
      >
        <Grid item>
          <Link href="/">NFuTure</Link>
        </Grid>
        <Grid item>
          <Button variant="contained" onClick={buttonAction}>
            {buttonText}
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};
